import React from 'react'
import { useLoading } from './LoadingOverlayContext'

const LoadingOverlay = () => {
  const { isLoading } = useLoading()

  if (!isLoading) return null

  return (
    <div className="loading-overlay">
      <div className="spinner"></div>
    </div>
  )
}

export default LoadingOverlay
